import { APP_BASE_HREF, NgOptimizedImage } from '@angular/common';
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostListener,
    Inject,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateTime } from 'luxon';
import { lastValueFrom } from 'rxjs';
import { DocInfoModalComponent } from 'src/app/modals/doc-info-modal/doc-info-modal.component';
import { ServModalComponent } from 'src/app/modals/service-modal/service-modal.component';
import {
    formatUiDate,
    toDateTime,
    uniqueDateTimesByDay,
} from 'src/app/shared/date/date.utils';
import { LoadService } from 'src/app/services/application/load.service';
import { DoctorService } from 'src/app/services/doctor.service';
import { Utils } from 'src/app/services/utils';
import {
    expandedAnimation,
    rightPanelAnimation,
} from '../../animations/height.animation';
import { IPeriod } from '../../interfaces/period.interfaces';
import {
    IDepartment,
    IDep,
    IDoctor,
    IFilial,
    IRecTalon,
    IRnumbDate,
    IServ,
    ISpec,
    ISpecByDep,
    IStaticFilter,
} from '../../interfaces/record.interfaces';
import { IService } from '../../interfaces/services.interfaces';
import { ConfigService } from '../../services/application/config.service.';
import { RecordService } from '../../services/record.service';
import { strToDate } from '../application/global.function';
import { AbortManagerService } from 'src/app/services/application/abort-manager.service';
import { keyframes } from '@angular/animations';

@Component({
    selector: 'app-rec-pc',
    templateUrl: './rec.component.html',
    styleUrls: ['./rec.component.scss'],
    animations: [expandedAnimation, rightPanelAnimation],
    standalone: false,
})
export class RecComponent implements OnInit, AfterViewInit, OnDestroy {
    private abortController: AbortController | null = null;
    public statusTab: number = 1; // Тип закладки (0-По филиалу, 1- По специальности)
    public isLoading = true;
    public isSpecLoading: boolean = false;
    public isMobile: boolean = false;
    private mediaQuery: MediaQueryList | undefined;
    private mediaQueryListener:
        ((this: MediaQueryList, ev: MediaQueryListEvent) => any) | null = null;

    @ViewChild('InputBlocSpec') public InputBlocSpecEL: ElementRef | undefined;
    @ViewChild('InputBlocServ') public InputBlocServEL: ElementRef | undefined;
    public originalSrvLists: { [doctorId: number]: IServ[] } = {};
    public searchInputValue: { [doctorId: string]: string } = {};
    public showMobilePicker: boolean = false;

    @HostListener('document:click', ['$event'])
    public handleClickOutside(event: MouseEvent) {
        const clickedElement = event.target as HTMLElement;

        // Close all open dropdowns if click is outside any service-select
        Object.keys(this.openSelectStates).forEach((key) => {
            const doctorId = Number(key);
            if (this.openSelectStates[doctorId]) {
                const dropdownContainer = document.querySelector(
                    `[data-doctor-id="${doctorId}"]`,
                );
                if (
                    dropdownContainer &&
                    !dropdownContainer.contains(clickedElement)
                ) {
                    this.openSelectStates[doctorId] = false;
                }
            }
        });

        // Existing logic for other dropdowns (e.g., search lists)
        if (
            !clickedElement.closest('.search-list') &&
            this.selectedFilial &&
            !clickedElement.closest('.filter__wrapper')
        ) {
            // this.isSearchListVisible = false;
            this.searchAmine = 'off';
        }

        if (
            !clickedElement.closest('.filter__dropdown-list') &&
            !clickedElement.closest('.filter__dropdown-toggle')
        ) {
            this.isDropdownOpen = false;
        }
    }

    public _specList: ISpec[] = []; // полный список
    public specList: ISpec[] = []; // Отфильтрованный
    public _filialList: IFilial[] = []; // полный список филиалов
    public filialList: IFilial[] = []; // Отфильтрованный
    public specByFilialList: ISpecByDep[] = []; // Список специальностей по филиалу
    public _specByFilialList: ISpecByDep[] = []; // Список специальностей по филиалу filtred
    public searchStr: string = ''; // Строка поиска
    // searchStrSrv: string = ''; // Строка поиска услуги у доктора
    public searchStrSrv: { [doctorId: number]: IServ[] } = {};
    public searchAmine = 'off';
    public panelRnumbAmine = 'off';

    public staticFilterBTNs: IStaticFilter[] = []; // Список кнопок фильтра сверху страницы
    public staticFilterSelected: any; // выбраные фильтр
    public selectedDoctor: IDoctor | undefined; //Doctor
    public selectDoc: IDoctor | null = null;
    public periodStart: Date = new Date();
    public periodEnd: Date = new Date();
    public talonPickerAnime = 'off';
    public selectedSpec: ISpec | null = null;
    public selectedFilial: IFilial | null = null;

    public dtBegin: Date | null = null; // Дата начала
    public dtEnd: Date | null = null; // Дата ококнчания
    public orderUP = true; // С начала последние
    public orderUPText: string = 'Сначала последние';

    public recList: IService[] | null = null;
    public recDoctors: IDoctor[] | null = null;
    public selectedSrv: IServ | undefined | null;
    public recListLength: number = 0; // Количество записей

    public paramsTalonpicker!: IRnumbDate;
    public showTalonPicker = false;
    //мобильный фильтр
    public isDropdownOpen = false;
    public isMobileFlilterOpen = false;
    public activeItem: any;
    public openMobileTemplate = false;
    public isSearchListVisible: boolean = true;
    public isFilialListVisible: boolean = true;
    public isFilialMode: boolean = false;
    public _wasVisible = false;
    private _showCalendar = false;
    public get showCalendar() {
        return this._showCalendar;
    }
    public set showCalendar(value: boolean) {
        if (value) {
            this._wasVisible = true;
        }
        this._showCalendar = value;
    }

    public constructor(
        private configS: ConfigService,
        private ds: DoctorService,
        private rs: RecordService,
        private modalService: NgbModal,
        private title: Title,
        private cdref: ChangeDetectorRef,
        private load: LoadService,
        private abortManager: AbortManagerService,
        @Inject(APP_BASE_HREF) private baseHref: string,
    ) {
        this.isFilialMode =
            !!this.load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.RECORD
                .IS_FILIAL_MODE;
        const tmpTitle =
            load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.RECORD.TITLE;
        if (tmpTitle) this.title.setTitle(tmpTitle);
    }
    public ngOnInit(): void {
        this.periodStart = new Date();
        this.periodEnd = toDateTime(this.periodStart)
            .plus({ days: 30 })
            .toJSDate();
        this.btnFiltrTek();
        if (this.isFilialMode) {
            this.isFilialListVisible = true;
            this.changeTab(0);
        }
        this.getStaticfilterBTN();
        if (!this.isFilialMode) this.getSpecList();
        this.getFilialList();
        this.selectedSpec = null;
        this.selectedFilial = null;
        this.selectedSrv = null;
        this.searchClick();
        //автоматическое переключение с десктопной версии на мобильную на всякий случай
        this.mediaQuery = window.matchMedia('(max-width: 767px)');
        this.mediaQueryListener = (e) => {
            this.isMobile = e.matches;
            if (!this.isMobile) this.openMobileTemplate = false;
        };
        this.mediaQuery.addListener(this.mediaQueryListener);
        this.isMobile = this.mediaQuery.matches;
        if (!this.isMobile) this.openMobileTemplate = false;

        //автоматическое переключение с десктопной версии на мобильную на всякий случай Конец
    }
    public ngAfterViewInit() {
        setTimeout(() => {
            this.isSearchListVisible = true;
            this.searchAmine = 'on';

            this.cdref.detectChanges();
        }, 0);
        this.isLoading = true;
        this.toggleTabPosition();
    }

    public ngOnDestroy() {
        if (this.mediaQueryListener) {
            this.mediaQuery?.removeListener(this.mediaQueryListener);
        }
        ['doc_list', 'spec_list'].forEach((key) => {
            this.abortManager.reset(key);
        });
        this.abortRequest();
    }
    public experienceText(exp: string): string {
        return Utils.experienceText(exp);
    }
    public changeTab(n: number) {
        this.searchAmine = '';
        //this.isLoading = true;
        this.abortRequest();

        if (n === 0) {
            this.staticFilterSelected = null;
            this.filialList = this._filialList;
        } else {
            if (this._specList.length === 0 && !this.isSpecLoading) {
                this.getSpecList();
            } else {
                this.specList = this._specList;
            }
        }
        //this.isLoading = false;
        this.statusTab = n;
        setTimeout(() => {
            this.isFilialListVisible = true;
            this.isSearchListVisible = true;
        }, 0);
        this.onTalonPickerClosed();
        this.paramsTalonpicker = {
            doctorId: 0,
            periodStart: new Date(),
            periodEnd: new Date(new Date().setDate(new Date().getDate() + 30)),
            depId: null,
        };
        this.openMobileTemplate = false;
        this.selectedSpec = null;
        this.selectedFilial = null;
        //this.cdref.detectChanges();
        this.recDoctors = [];
        this.selectedSpec = null;
        this.searchStr = '';
        this.selectedSrvMap = {};
        this.toggleTabPosition();
    }

    public toggleTabPosition() {
        const headerTabs = document.querySelector('.header__tabs');
        if (this.statusTab === 1) {
            headerTabs?.classList.add('tab-right');
        } else {
            headerTabs?.classList.remove('tab-right');
        }
    }
    public setDoctorsExpAndSpec() {
        this.recDoctors?.forEach((item, index) => {
            if (this.recDoctors) {
                this.recDoctors[index].workExp =
                    item?.infoDoc?.find((value) =>
                        value.queston.toLowerCase().includes('стаж'),
                    )?.answer || '';
                this.recDoctors[index].workSpec =
                    item?.infoDoc?.find(
                        (value) =>
                            value.queston
                                .toLowerCase()
                                .includes('направление') ||
                            value.queston
                                .toLowerCase()
                                .includes('специальность') ||
                            value.queston
                                .toLowerCase()
                                .includes('специализация'),
                    )?.answer || '';
            }
        });
    }

    // Получить список специальностей
    public getSpecList() {
        if (this.isSpecLoading) return; // || this._specList.length > 0
        this.isLoading = true;
        this.isSpecLoading = true;
        this.specList = [];
        this._specList = [];
        let staticId: number | null = null;
        if (this.staticFilterSelected) {
            staticId = this.staticFilterSelected;
        }

        this.rs
            .getSpecList(this.periodStart, this.periodEnd, staticId)
            .subscribe({
                next: (val) => {
                    this.specList = val.sort((a, b) => {
                        const aText = a.text.toUpperCase(),
                            bText = b.text.toUpperCase();
                        if (aText < bText) {
                            return -1;
                        }
                        if (aText > bText) {
                            return 1;
                        }
                        return 0;
                    });
                    this.specList = val;
                    this._specList = this.specList;

                    this.isLoading = false;
                    this.isSpecLoading = false;
                    this.cdref.detectChanges();
                },
                error: (error) => {
                    console.error(error);
                    this.isLoading = false;
                    this.isSpecLoading = false;
                    this.cdref.detectChanges();
                },
            });

        this.setSearchListVisible(true);
        this.searchAmine = 'on';
    }
    public getFilialList() {
        this.isLoading = true;
        this.isFilialListVisible = true;
        this.rs.getFilialList().subscribe({
            next: (val) => {
                this.filialList = val;
                this._filialList = this.filialList;
                this.isLoading = false;

                this.cdref.detectChanges();
            },
            error: (error) => {
                console.error(error);
                this.isLoading = false;
                this.cdref.detectChanges();
            },
        });
    }
    public getSpecByFilialList(depId: number) {
        this.isLoading = true;
        this.specByFilialList = [];

        this.rs
            .getSpecList(
                this.periodStart,
                this.periodEnd,
                null, // staticId
                depId,
            )
            .subscribe({
                next: (val) => {
                    this.specByFilialList = val
                        .sort((a, b) => {
                            const aText = a.text.toUpperCase(),
                                bText = b.text.toUpperCase();
                            return aText.localeCompare(bText);
                        })
                        .map((item) => ({ ...item, depid: depId }));

                    this._specByFilialList = [...this.specByFilialList];
                    // Отключаем лоадер только после обработки данных
                    setTimeout(() => {
                        this.isLoading = false;
                    }, 100);
                    this.cdref.detectChanges();
                },
                error: (error) => {
                    console.error(error);
                    this.isLoading = false; // Важно отключить лоадер даже при ошибке
                    this.cdref.detectChanges();
                },
            });
    }
    public initializeOriginalServiceLists(): void {
        if (this.recDoctors) {
            this.recDoctors.forEach((doctor) => {
                if (doctor.srvList && doctor.srvList.length > 0) {
                    this.originalSrvLists[doctor.doctorId] = [
                        ...doctor.srvList,
                    ];
                }
            });
        }
    }
    // Получить список докторов по специальности и филиалу
    public getDocList(
        p_SpecID: number,
        p_depID: number | null,
        signal?: AbortSignal,
    ) {
        let staticId: number | null = null;
        if (this.staticFilterSelected && this.staticFilterSelected.keyid) {
            staticId = this.staticFilterSelected.keyid;
        }
        return this.rs.getDocList(
            p_SpecID,
            this.periodStart,
            this.periodEnd,
            staticId,
            p_depID,
            signal,
        );
    }

    public selectSpec(specId: number, depId: number | null) {
        if (this.abortController) {
            this.abortController.abort();
        }
        const currentController = new AbortController();
        this.abortController = currentController;

        this.isSearchListVisible = false;
        this.isFilialListVisible = false;
        this.isDropdownOpen = false;

        this.recDoctors = [];
        this.isLoading = true;
        this.originalSrvLists = {};
        this.selectedSpec = this.specList.length
            ? this.specList.filter((item) => item.keyId === specId)[0]
            : this.specByFilialList.filter((item) => item.keyId === specId)[0];
        this.searchAmine = 'off';
        this.searchStr = this.selectedSpec?.text;

        this.setSearchListVisible(false);

        this.getDocList(specId, depId, currentController.signal).subscribe({
            next: (val) => {
                const currentDoctors = val;
                this.recDoctors = currentDoctors;

                this.recDoctors.forEach((item) => {
                    item.rdatemin = strToDate(item.datBgn);
                    item.rdatemax = strToDate(item.datEnd);
                    if (item.srvList?.length) {
                        this.originalSrvLists[item.doctorId] = [
                            ...item.srvList,
                        ];
                    }
                });
                this.recDoctors.sort((a, b) => a.lName.localeCompare(b.lName));

                const docInfoPromises = currentDoctors.map((doc) =>
                    lastValueFrom(this.ds.getDocAboutInfo(doc.doctorId)),
                );

                Promise.allSettled(docInfoPromises).then((res) => {
                    res.forEach((info, i) => {
                        if (info.status === 'fulfilled') {
                            currentDoctors[i].infoDoc = info.value;
                        }
                    });
                    this.setDoctorsExpAndSpec();
                    this.initializeOriginalServiceLists();
                    this.isLoading = false;
                });
            },
            error: (error) => {
                if (
                    error.name === 'AbortError' ||
                    error.name === 'CanceledError'
                ) {
                    return;
                }
                console.error(error);
                this.isLoading = false;
            },
        });
        this.paramsTalonpicker = {
            doctorId: 0,
            //srvId: specId, // идентичен со specId \/ (см ниже)
            periodStart: this.periodStart,
            periodEnd: this.periodEnd,
            specId: this.selectedSpec.keyId, // (здесь) идентичен с srvId, передается одно и то же
            srv: this.selectedSrv ? this.selectedSrv : undefined,
            Idep: this.selectedFilial ? this.selectedFilial : undefined,
            depId: this.selectedFilial?.depId
                ? this.selectedFilial.depId
                : null,
        };

        if (window.innerWidth < 500) {
            this.openMobileTemplate = true;
            setTimeout(() => {
                this.cdref.detectChanges();
            }, 0);
        } else {
            this.openMobileTemplate = false;
        }
        this.talonPickerAnime = 'on';

        this.isSearchListVisible = false;
    }

    public selectFil(depId: number) {
        // this.isSearchListVisible = false;
        this.selectedFilial = this.filialList.filter(
            (item) => item.depId == depId,
        )[0];
        this.searchStr = '';
        this.searchAmine = 'off';
        // this.searchStr = this.selectedFilial.dep_name;
        this.getSpecByFilialList(depId);

        if (window.innerWidth < 500) {
            this.openMobileTemplate = false;
        } else {
            this.openMobileTemplate = false;
        }

        this.talonPickerAnime = 'on';
        this.isSearchListVisible = true;
    }

    public onSearchChange(searchValue: string): void {}
    public changeSearch(str: string) {
        if (this.statusTab === 1) {
            if (str.length > 0) {
                this.specList = this._specList.filter(
                    (item) =>
                        item.text.toUpperCase().indexOf(str.toUpperCase()) !==
                        -1,
                );
            } else {
                this.specList = this._specList;
            }
        } else {
            if (!this.selectedFilial) {
                this.filialList = this._filialList.filter(
                    (item) =>
                        item.depName
                            .toUpperCase()
                            .indexOf(str.toUpperCase()) !== -1,
                );
            }

            if (str.length > 0) {
                this.specByFilialList = this._specByFilialList.filter(
                    (item) =>
                        item.text.toUpperCase().indexOf(str.toUpperCase()) !==
                        -1,
                );
            } else {
                this.specByFilialList = this._specByFilialList;
            }
        }
    }

    public changeSearchSrv(searchText: string, doctorId: number): void {
        // ищем доктор в общем списке
        const doctor = this.recDoctors?.find(
            (doc) => doc.doctorId === doctorId,
        );

        if (!doctor) return;

        if (!this.originalSrvLists[doctorId] && doctor.srvList) {
            this.originalSrvLists[doctorId] = [...doctor.srvList];
        }

        // если строка пустая
        if (!searchText || searchText.trim() === '') {
            if (this.originalSrvLists[doctorId]) {
                doctor.srvList = [...this.originalSrvLists[doctorId]];
            }
            return;
        }

        // Filter services based on search text
        if (this.originalSrvLists[doctorId]) {
            const searchLower = searchText.toLowerCase();
            doctor.srvList = this.originalSrvLists[doctorId].filter(
                (service) =>
                    service.text.toLowerCase().includes(searchLower) ||
                    (service.description &&
                        service.description
                            .toLowerCase()
                            .includes(searchLower)),
            );
        }
    }

    public searchClick() {
        this.panelRnumbAmine = 'off';
        if (this.searchAmine === 'off') {
            this.searchAmine = 'on';
        } else {
            this.searchAmine = 'off';
        }

        // Если специальность не меняется
        if (this.searchAmine === 'off' && this.selectDoc) {
            if (this.selectDoc.srvList && this.selectDoc.srvList.length > 0) {
                if (this.selectedSrv) {
                    this.panelRnumbAmine = 'on';
                    this.showCalendar = true;
                }
            } else {
                this.panelRnumbAmine = 'on';
            }
        }
    }

    public changePeriod(dt: IPeriod) {
        //
        this.dtBegin = dt.begin;
        this.dtEnd = dt.end;
        //    this.getServicesSize();
    }

    // За сегодня
    public btnFiltrTek() {
        this.dtBegin = new Date();
        this.dtEnd = new Date();
        this.changePeriod({ begin: this.dtBegin, end: this.dtEnd });
    }

    // За 3 дня
    public btnFiltr3Day() {
        this.dtBegin = new Date();
        this.dtBegin.setDate(this.dtBegin.getDate() - 3);
        this.dtEnd = new Date();
        this.changePeriod({ begin: this.dtBegin, end: this.dtEnd });
    }

    public getPeriodStr(dt1?: Date, dt2?: Date): string {
        return `(${formatUiDate(dt1)} - ${formatUiDate(dt2)})`;
    }
    public getImgSrcFilials(id: number): string {
        return `${this.configS.getValue('hostBackend')}/img/filials/${id}.png`;
    }
    public getImgSrcSpec(id: number): string {
        return `${this.configS.getValue('hostBackend')}/img/spec/${id}.png`;
    }

    /**
     * В случае если изображение на сервере не найдено то грузим локальное изображение
     * @param event
     */
    public errorHandlerIMG(event: any, type: string): void {
        const elem = event.target as HTMLImageElement;

        if (elem.dataset.defaultImageSet === 'true') {
            return;
        }
        let localFallback = '';
        switch (type) {
            case 'filial':
                localFallback = `${this.baseHref}assets/images/placeholders/facility.png`;
                elem.src = localFallback;
                break;

            case 'spec':
                localFallback = `${this.baseHref}assets/images/placeholders/specialist.png`;
                elem.src = localFallback;
                break;
        }

        elem.dataset.defaultImageSet = 'true';
    }

    /* Выбор доктора */
    public selectedDoc(doc: IDoctor) {
        this.selectDoc = doc;
        this.selectedSrv = null;
        // this.RnumbDateSetParams();
    }

    /* передача параметров в номерки */
    public RnumbDateSetParams() {
        this.paramsTalonpicker = {
            doctorId: this.selectedDoctor?.doctorId!,
            specId: this.selectedSpec?.keyId,
            periodStart: this.periodStart,
            periodEnd: this.periodEnd,
            srv: this.selectedSrv!,
            staticFilterSelected: this.staticFilterSelected!,
            infoDoc: this.selectedDoctor
                ? this.selectedDoctor.infoDoc
                : this.selectDoc?.infoDoc,
            Idep: this.selectedFilial ? this.selectedFilial : undefined,
            depId: this.selectedFilial?.depName
                ? this.selectedFilial.depId
                : null,
            selectedDoctor: this.selectedDoctor,
            selectedSpec:
                this.selectedSpec !== null ? this.selectedSpec : undefined,
        };

        if (
            this.selectDoc &&
            this.selectDoc.srvList &&
            this.selectDoc.srvList.length > 0
        ) {
            // c услугами , this.selectedSrv определяеться при выборе услуги из выпадающего списка список модалка
            if (this.selectedSrv) {
                this.panelRnumbAmine = 'on'; // Включить анимацию

                let param: IRnumbDate = {
                    doctorId: 0,
                    specId: 0,
                    periodStart: new Date(),
                    periodEnd: new Date(),
                    srv: this.selectedSrv,
                    depId: null,
                };
                param.doctorId = this.selectDoc.doctorId;
                if (this.selectedSpec) {
                    param.specId = this.selectedSpec.keyId;
                }
                param.periodStart = this.periodStart;
                param.periodEnd = this.periodEnd;
                if (this.staticFilterSelected) {
                    param.staticFilterSelected = this.staticFilterSelected;
                }
                this.rs.RnumbDateSetParams(param);

                this.showCalendar = true;
            } else {
                this.panelRnumbAmine = 'off';
            }
        } else {
            // Без услуг
            this.panelRnumbAmine = 'on'; // Включить анимацию
            let param: IRnumbDate = {
                doctorId: 0,
                specId: 0,
                periodStart: new Date(),
                periodEnd: new Date(),
                depId: null,
            };
            // @ts-ignore
            param.doctorId = this.selectDoc?.doctorid;
            if (this.selectedSpec) {
                param.specId = this.selectedSpec.keyId;
            }
            param.periodStart = this.periodStart;
            param.periodEnd = this.periodEnd;
            if (this.staticFilterSelected) {
                param.staticFilterSelected = this.staticFilterSelected;
            }

            this.rs.RnumbDateSetParams(param);
        }
        if (window.innerWidth < 500) {
            this.openMobileTemplate = true;
            this.showCalendar = false;
        } else {
            this.showCalendar = true;
        }
    }
    /* Список кнопок */
    public getStaticfilterBTN() {
        this.staticFilterBTNs = [];
        this.staticFilterSelected = null;
        this.rs.getStacfilterList().subscribe({
            next: (val) => {
                this.staticFilterBTNs = val;
            },
            error: (error) => {
                console.error(error);
            },
        });
    }

    /* фильтр */

    public btnStaticFiltr(btnST: IStaticFilter) {
        if (this.staticFilterSelected !== btnST.keyId) {
            this.staticFilterSelected = btnST.keyId;
        } else {
            this.staticFilterSelected = null;
        }

        this.getSpecList();
        this.cdref.detectChanges();
        this.recDoctors = [];
        this.searchStr = '';
        this.searchAmine = 'on';
        this.setSearchListVisible(true);
    }
    public setSearchListVisible(value: boolean) {
        this.isSearchListVisible = value;
    }

    public onClosePanelTalon(event: number) {
        this.selectDoc = null;
        this.panelRnumbAmine = 'off';
    }

    public isShowSrvList(doc: IDoctor): boolean {
        if (doc && doc.srvList && doc.srvList.length > 0) {
            return true;
        } else {
            return false;
        }
    }

    public invalidSrv(doctorid: number): boolean {
        let f: boolean = false;
        if (
            this.selectDoc &&
            this.selectDoc.doctorId == doctorid &&
            !this.selectedSrv
        ) {
            f = true;
        }
        return f;
    }
    public openDocInfoModal(doc: IDoctor, event: Event) {
        event.stopPropagation();
        const modal = this.modalService.open(DocInfoModalComponent);
        modal.componentInstance.doc = doc;
        modal.componentInstance.spec = this.selectedSpec?.text;
    }

    public openServDescModal(docSrv: IServ, event: Event) {
        event.stopPropagation();
        const modal = this.modalService.open(ServModalComponent);
        modal.componentInstance.serv = docSrv;
    }

    public onTalonPickerClosed() {
        // this.showTalonPicker = false;
        this.showMobilePicker = false;
        this.showCalendar = false;
    }
    public toggleDropdown() {
        this.isDropdownOpen = !this.isDropdownOpen;
    }

    public onFilterChanged(event: any) {
        switch (event.typeEvent) {
            case 'clearFilter':
                this.staticFilterSelected = null;
                this.getSpecList();
                this.toggleDropdown();
                this.recList = [];
                this.searchStr = '';
                this.searchAmine = 'on';

                break;
            case 'getStacFilters':
                this.staticFilterBTNs = event.data;
                break;

            case 'filterListUpdated':
                this.cdref.detectChanges();
                this.staticFilterSelected = event.data;
                this.getSpecList();
                this.recDoctors = [];
                this.searchStr = '';
                this.toggleDropdown();
                break;
        }
    }

    // rcountText(count: number): string {
    //     if (!count) return 'Нет номерков';

    //     const lastDigit = count % 10;
    //     const lastTwoDigits = count % 100;

    //     if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
    //         return `Осталось ${count} номерков`;
    //     }

    //     switch (lastDigit) {
    //         case 1:
    //             return `Остался ${count} номерок`;
    //         case 2:
    //         case 3:
    //         case 4:
    //             return `Осталось ${count} номерка`;
    //         default:
    //             return `Осталось ${count} номерков`;
    //     }
    // }

    public formatDoctorName(fullName: string): string {
        const nameParts = fullName.split(' ');
        if (nameParts.length >= 2) {
            const lastName = nameParts[0];
            const initials = nameParts
                .slice(1)
                .map((part) => part.charAt(0) + '.')
                .join('');
            return `${lastName} ${initials}`;
        }
        return fullName;
    }
    public getFioDoc(doctor: IDoctor): string {
        if (!doctor || !doctor.lName || !doctor.fName) return '';
        return `${doctor.lName} ${doctor.fName} ${doctor.sName || ''}`;
    }
    public openSelectStates: { [key: number]: boolean } = {};

    public toggleSelect(doctorId: number) {
        if (this.openSelectStates.hasOwnProperty(doctorId)) {
            if (this.openSelectStates[doctorId]) {
                // закрываем выпадающий список если он уже открыт
                this.openSelectStates[doctorId] = false;
            } else {
                Object.keys(this.openSelectStates).forEach((key) => {
                    this.openSelectStates[Number(key)] = false;
                });
                this.openSelectStates[doctorId] = true;
            }
        } else {
            this.openSelectStates[doctorId] = true;
        }
    }
    public selectedSrvMap: { [key: number]: IServ } = {};
    public loadingCalendar = false;
    public showMobileServiceList: boolean = false;

    public openSrvList(event: { service: IServ; doctor: IDoctor }) {
        this.selectedSrv = event.service;
        this.selectedDoctor = event.doctor;
        this.showMobileServiceList = true;
    }
    public pickedDoctor: IDoctor | null = null;
    public pickDoc(event: { doctor: IDoctor }) {
        this.selectedDoctor = event.doctor;

        // Update paramsTalonpicker to include the doctor ID
        if (this.selectedDoctor) {
            this.paramsTalonpicker = {
                ...this.paramsTalonpicker,
                doctorId: this.selectedDoctor.doctorId,
                specId: this.selectedSpec?.keyId,
                periodStart: this.periodStart,
                periodEnd: this.periodEnd,
                selectedDoctor: this.selectedDoctor,
                Idep: this.selectedFilial ? this.selectedFilial : undefined,
                depId: this.selectedFilial?.depId
                    ? this.selectedFilial.depId
                    : null,
            };
        }

        // For mobile, show service list
        this.showMobileServiceList = true;
    }
    public checkSrv: boolean = false;
    public selectService(event: { service: IServ; doctor: IDoctor }) {
        const { service, doctor } = event;

        // this.pickDoc(event);

        this.selectedDoctor = doctor;
        this.activeItem = doctor;
        this.searchStrSrv = { ...service };
        this.loadingCalendar = true;

        if (doctor) {
            this.selectedSrv = service;
            this.selectedSrvMap[doctor.doctorId] = service;
            this.openSelectStates[doctor.doctorId] = false;

            // Make sure service.keyid exists before using it
            const srvId = service && service.keyId ? service.keyId : undefined;

            if (this.selectedSrv) {
                this.paramsTalonpicker = {
                    doctorId: this.selectedDoctor.doctorId,
                    //srvId: srvId,
                    periodStart: this.periodStart,
                    periodEnd: this.periodEnd,
                    specId: this.selectedSpec?.keyId,
                    srv: service,
                    infoDoc: this.selectedDoctor.infoDoc,
                    selectedDoctor: this.selectedDoctor,
                    selectedSpec: this.selectedSpec
                        ? this.selectedSpec
                        : undefined,
                    Idep: this.selectedFilial ? this.selectedFilial : undefined,
                    depId: this.selectedFilial?.depId
                        ? this.selectedFilial.depId
                        : null,
                };
            }

            if (this.isMobile) {
                this.showMobileServiceList = true;
            } else {
                this.showCalendar = true;
            }

            this.RnumbDateSetParams();
            setTimeout(() => {
                this.loadingCalendar = false;
            }, 1000);
        }
        this.cdref.detectChanges();
    }

    // Добавим методы для обработки событий от компонента карточки
    public handleToggleSelect(doctorId: number) {
        this.toggleSelect(doctorId);
        this.showCalendar = false;
    }

    public handleSearchSrvChanged(event: {
        searchText: string;
        doctorId: number;
    }) {
        this.changeSearchSrv(event.searchText, event.doctorId);
    }

    public handleOpenDocInfo(event: { doctor: IDoctor; event: Event }) {
        this.openDocInfoModal(event.doctor, event.event);
    }

    public handleOpenServDesc(event: { service: IServ; event: Event }) {
        this.openServDescModal(event.service, event.event);
    }

    public clearSearch(event?: Event) {
        if (event) {
            event.stopPropagation();
        }
        this.abortRequest();
        this.selectedSpec = null;
        this.searchStr = '';
        this.searchAmine = 'on';
        this.changeSearch(this.searchStr);
        this.openMobileTemplate = false;
        setTimeout(() => {
            this.isSearchListVisible = true;
        }, 100);
        this.isLoading = false;
    }

    public toggleSearchList(event: Event) {
        event.stopPropagation();
        this.showCalendar = false;
        this.searchAmine = 'on';
        if (this.statusTab === 0) {
        }

        if (window.innerWidth < 500 && this.openMobileTemplate) {
            this.isSearchListVisible = !this.isSearchListVisible;
            this.isLoading = false;
        } else {
            this.searchAmine = 'on';
            if (this.searchStr.length > 0 && this.recDoctors) {
                this.changeSearch(this.searchStr);

                this.isSearchListVisible = !this.isSearchListVisible;
            } else {
                this.isSearchListVisible = true;
            }
        }
        Object.keys(this.openSelectStates).forEach((key) => {
            this.openSelectStates[Number(key)] = false;
        });
    }

    public mobileFilterHandler() {
        this.isMobileFlilterOpen = !this.isMobileFlilterOpen;
    }
    public closeRegistrationPicker() {
        // this.selectedDoctor = undefined;

        this.openMobileTemplate = false;
    }

    // Обновленная функция getHeaderLabel в классе RecComponent
    public getHeaderLabel(): string {
        if (this.selectedFilial && this.selectedSpec) {
            // Если выбраны и филиал, и специальность, показываем оба с разделителем
            return `${this.selectedFilial.depName} > ${this.selectedSpec.text}`;
        } else if (this.selectedSpec) {
            // Если выбрана только специальность
            return this.selectedSpec.text;
        } else if (this.selectedFilial) {
            // Если выбран только филиал
            return this.selectedFilial.depName;
        } else {
            // Если ничего не выбрано
            return 'Филиалы';
        }
    }

    public goBackToFilial() {
        this.abortRequest();
        this.selectedFilial = null;
        this.selectedSpec = null;
        this.selectedSrv = null;
        this.selectedSrvMap = {};
        this.recDoctors = [];
        this.showCalendar = false;
        this.openMobileTemplate = false;
        this.searchStr = '';
        this.changeSearch(this.searchStr);

        this.isSearchListVisible = true;
        this.isFilialListVisible = true;
        this.cdref.detectChanges();
        this.isLoading = false;
    }

    /**
     * функция для возврата
     */
    public clearSelection() {
        this.abortRequest();
        if (this.statusTab === 0) {
            if (this.selectedSpec) {
                this.selectedSpec = null;
                this.recDoctors = [];
                this.showCalendar = false;
                this.openMobileTemplate = false;
                this.selectedSrvMap = {};
                this.searchStr = '';
                this.searchAmine = 'on';
                this.changeSearch(this.searchStr);
                this.isLoading = false;
                setTimeout(() => {
                    this.isSearchListVisible = true;
                }, 100);
            } else if (this.selectedFilial) {
                this.selectedFilial = null;
                this.searchStr = '';
                this.specByFilialList = [];
                this.isSearchListVisible = true;
            }
        } else {
            this.selectedSpec = null;
            this.recDoctors = [];
            this.searchStr = '';
            this.showCalendar = false;
            this.openMobileTemplate = false;
            this.getSpecList();
            this.isSearchListVisible = true;
            this.searchAmine = 'on';
        }
        this.cdref.detectChanges();
    }

    public backToSrv() {}
    public isCalendarActive: boolean = false;
    public showCalendarIcon: boolean = false;
    public calendarHandler(): void {
        this.isCalendarActive = !this.isCalendarActive;
    }

    public getFullName(doctor?: IDoctor | null): string {
        if (!doctor) return '';
        return `${doctor.lName || ''} ${doctor.fName || ''} ${
            doctor.sName || ''
        }`.trim();
    }
    public showDropdown: boolean = false;
    public selectedDep: IDep | null = null;
    public depList: IDepartment[] = [];
    public talonListAll: IRecTalon[] = [];
    public depPicked: boolean = false;
    public talonListFiltered: IRecTalon[] = [];
    public headerTxt = ''; // Заголовок
    public selectedDay: DateTime | null = DateTime.local();
    public activeDays: DateTime[] = []; // NOT sorted by date

    public placeholderDep(): string {
        return this.selectedDep ? this.selectedDep.text : 'Выберите филиал';
    }

    private async getDepList(params: IRnumbDate) {
        this.depList = await lastValueFrom(this.rs.getDepListv2(params));
        this.depList = this.depList.filter((dep) => {
            const deps = new Set();
            this.talonListAll.forEach((talon) => deps.add(talon.depId));
            return deps.has(dep.keyId);
        });
    }

    public selectDep(dep: IDepartment | null) {
        this.showCalendarIcon = true;
        this.headerTxt = formatUiDate(this.selectedDay);
        if (dep?.keyId === -1) {
            this.selectedDep = null;

            this.depPicked = true;
            this.showDropdown = false;
            this.talonListFiltered = this.filterTalons();
        } else {
            this.selectedDep = dep;
            this.showDropdown = false;
            this.talonListFiltered = this.filterTalons();
        }
        this.activeDays = this.filterActiveDays();
    }

    public filterTalons() {
        return this.talonListAll.filter((talon) => {
            return (
                Boolean(
                    this.selectedDay &&
                    toDateTime(strToDate(talon.datBeginStr)).hasSame(
                        this.selectedDay,
                        'day',
                    ),
                ) &&
                (this.selectedDep
                    ? talon.depId === this.selectedDep.keyId
                    : true)
            );
        });
    }

    private filterActiveDays() {
        if (!this.selectedDep) {
            this.activeDays = uniqueDateTimesByDay(
                this.talonListAll.map((talon) =>
                    toDateTime(strToDate(talon.datBeginStr)),
                ),
            );
        } else {
            this.activeDays = uniqueDateTimesByDay(
                this.talonListAll
                    .filter((talon) => talon.depId === this.selectedDep?.keyId)
                    .map((talon) => toDateTime(strToDate(talon.datBeginStr))),
            );
        }
        return this.activeDays;
    }

    public closeMobileServiceList(): void {
        this.showMobileServiceList = false;
    }

    public abortRequest() {
        if (this.abortController) {
            this.abortController.abort();
            this.abortController = null;
        }
    }

    public srvChanged(event: { typeEvent: string; data: IServ }): void {
        // this.selectedSpec?.keyid = event.data.srvId;

        if (event.data && event.data.keyId) {
            this.selectedSrv = event.data;
            this.paramsTalonpicker.srv = event.data;

            if (this.selectedSpec) {
                this.paramsTalonpicker.specId = this.selectedSpec.keyId;
            }

            if (this.selectedDoctor) {
                this.paramsTalonpicker.doctorId = this.selectedDoctor.doctorId;
            }
        }

        this.RnumbDateSetParams();
        this.showMobileServiceList = false;
        this.showMobilePicker = true;
    }
}
